<!--Old-->
<!--<div class="modal-header">-->
<!--  <h4 class="modal-title pull-left no-text-transform"> Attenzione</h4>-->
<!--  <button type="button" class="close pull-right" aria-label="Close" (click)="decline()">-->
<!--    <span aria-hidden="true">&times;</span>-->
<!--  </button>-->
<!--</div>-->
<!--<div class="container-fluid py-15 text-center">-->
<!--  Stai per cancellare l'invito.L'azione sara irrevirreversibile-->
<!--</div>-->
<!--<div class="modal-footer d-flex justify-content-between">-->
<!--  <button (click)="confirm()" class="btn btn-solid btn-small ml-15">-->
<!--    {{'general.confirm' | translate}}-->
<!--  </button>-->
<!--  <button (click)="decline()" class="btn-solid btn-small black-btn">-->
<!--    {{'general.cancel' | translate}}-->
<!--  </button>-->
<!--</div>-->

<div class="confirm-modal">
  <div class="custom-modal-header">
    <h4 class="modal-title no-text-transform"> {{ 'general.ATTENTION' | translate }} </h4>
    <button type="button" class="x" aria-label="Close" (click)="decline()">
      <div class="x-shape"></div>
    </button>
  </div>

  <div class="container-fluid py-15 modal-message">
    {{ 'general.pr_attention_text' | translate }}
  </div>

  <div class="final-buttons">
    <button (click)="decline()" class="btn-no btn-light-grey btn-cart-summary text-uppercase">
      {{'general.cancel' | translate}}
    </button>
    <button (click)="confirm()" class="btn-cart-summary orange-shadow btn-orange text-uppercase">
      {{'general.confirm' | translate}}
    </button>
  </div>
</div>
